import { defineMessages } from 'react-intl'

export const featureMessages = defineMessages({
  trackYourCalories: {
    id: 'featureMessages.trackYourCalories',
    defaultMessage: 'Track your calories'
  },
  monitorYourMacros: {
    id: 'featureMessages.monitorYourMacros',
    defaultMessage: 'Monitor your macros'
  },
  checkYourFormWithVideo: {
    id: 'featureMessages.checkYourFormWithVideo',
    defaultMessage: 'Check your form with AI'
  },
  recommendedWorkouts: {
    id: 'featureMessages.recommendedWorkouts',
    defaultMessage: 'Recommended workouts'
  },
  workoutTracker: {
    id: 'featureMessages.workoutTracker',
    defaultMessage: 'Workout tracker'
  },
  exerciseVideos: {
    id: 'featureMessages.exerciseVideos',
    defaultMessage: '1500+ exercise videos'
  },
  personalizedWorkoutPlans: {
    id: 'featureMessages.personalizedWorkoutPlans',
    defaultMessage: 'Personalized workout plans'
  },
  progressMonitoring: {
    id: 'featureMessages.progressMonitoring',
    defaultMessage: 'Progress monitoring'
  },
  workoutReminders: {
    id: 'featureMessages.workoutReminders',
    defaultMessage: 'Workout reminders'
  },
  smartPlanAndWorkoutBuilder: {
    id: 'featureMessages.smartPlanAndWorkoutBuilder',
    defaultMessage: 'Smart plan & workout builder'
  },
  trackYourCaloriesDescription: {
    id: 'featureMessages.trackYourCaloriesDescription',
    defaultMessage: 'Track calories using a photo, your voice, or by typing it in. Fast, smart, and easy with AI.'
  },
  monitorYourMacrosDescription: {
    id: 'featureMessages.monitorYourMacrosDescription',
    defaultMessage: 'See your daily protein, carbs, and fat intake. Understanding your macros helps you stay consistent and make better food choices to reach your goals.'
  },
  checkYourFormWithVideoDescription: {
    id: 'featureMessages.checkYourFormWithVideoDescription',
    defaultMessage: 'Record yourself doing an exercise and get instant AI feedback on your form, posture, and movement quality to help you train safer and improve faster.'
  },
  recommendedWorkoutsDescription: {
    id: 'featureMessages.recommendedWorkoutsDescription',
    defaultMessage: 'You can find a wide range of home and gym workouts for every goal in the Gymaholic App.'
  },
  workoutTrackerDescription: {
    id: 'featureMessages.workoutTrackerDescription',
    defaultMessage: 'You can forget about your notebook or excel spreadsheet. Track reps, weights, and learn how to perform the exercises properly with our beautiful workout experience.'
  },
  exerciseVideosDescription: {
    id: 'featureMessages.exerciseVideosDescription',
    defaultMessage: 'A large exercise library that will help you perform movements with the right form and find variations with ease. Can’t find an exercise? Don’t worry you can create your own.'
  },
  personalizedWorkoutPlansDescription: {
    id: 'featureMessages.personalizedWorkoutPlansDescription',
    defaultMessage: 'A goal without a plan is just a wish.{br}Edit your plans and workouts according to your goals and schedule.'
  },
  progressMonitoringDescription: {
    id: 'featureMessages.progressMonitoringDescription',
    defaultMessage: 'Always progressing. Track detailed metrics to help you plan your workouts accordingly.'
  },
  workoutRemindersDescription: {
    id: 'featureMessages.workoutRemindersDescription',
    defaultMessage: 'Never miss a workout. You will get notifications to hold yourself accountable.'
  },
  smartPlanAndWorkoutBuilderDescription: {
    id: 'featureMessages.smartPlanAndWorkoutBuilderDescription',
    defaultMessage: 'Tailor your workouts to your needs. Create personalized workouts based on your fitness level and equipment available.'
  }
})

export const FREE_FEATURE_MESSAGES = [
  featureMessages.recommendedWorkouts,
  featureMessages.workoutTracker,
  featureMessages.exerciseVideos
]

export const PREMIUM_FEATURE_MESSAGES = [
  featureMessages.personalizedWorkoutPlans,
  featureMessages.checkYourFormWithVideo,
  featureMessages.progressMonitoring,
  featureMessages.workoutReminders,
  featureMessages.smartPlanAndWorkoutBuilder,
  ...FREE_FEATURE_MESSAGES
]

export const PREMIUM_PLUS_FEATURE_MESSAGES = [
  featureMessages.trackYourCalories,
  featureMessages.monitorYourMacros,
  ...PREMIUM_FEATURE_MESSAGES
]

export const FEATURE_MESSAGES = [
  ...PREMIUM_PLUS_FEATURE_MESSAGES
]

export const FREE_FEATURE_DESCRIPTION_MESSAGES = [
  featureMessages.recommendedWorkoutsDescription,
  featureMessages.workoutTrackerDescription,
  featureMessages.exerciseVideosDescription
]

export const PREMIUM_FEATURE_DESCRIPTION_MESSAGES = [
  featureMessages.personalizedWorkoutPlansDescription,
  featureMessages.checkYourFormWithVideoDescription,
  featureMessages.progressMonitoringDescription,
  featureMessages.workoutRemindersDescription,
  featureMessages.smartPlanAndWorkoutBuilderDescription,
  ...FREE_FEATURE_DESCRIPTION_MESSAGES
]

export const PREMIUM_PLUS_FEATURE_DESCRIPTION_MESSAGES = [
  featureMessages.trackYourCaloriesDescription,
  featureMessages.monitorYourMacrosDescription,
  ...PREMIUM_FEATURE_DESCRIPTION_MESSAGES
]

export const FEATURE_DESCRIPTION_MESSAGES = [
  ...PREMIUM_PLUS_FEATURE_DESCRIPTION_MESSAGES
]

export const FEATURE_IMAGE_SOURCES = [
  '/app/landing/landing-meal-feature.png',
  '/app/landing/landing-monitor-macros.png',
  '/app/premium/started-plan.png',
  '/app/landing/landing-checkYourForm.png',
  '/app/premium/progress.png',
  '/app/premium/reminders.png',
  '/app/premium/smart.png',
  '/app/landing/workouts.png',
  '/app/landing/workout.png',
  '/app/landing/exercises.png'
]

export const FEATURE_NAME_TO_IMAGE_SOURCE = {
  TRACK_YOUR_CALORIES: '/app/landing/landing-meal-feature.png',
  MONITOR_YOUR_MACROS: '/app/landing/landing-monitor-macros.png',
  CHECK_YOUR_FORM_WITH_VIDEO: '/app/landing/landing-checkYourForm.png',
  PERSONALIZED_WORKOUT_PLANS: '/app/premium/started-plan.png',
  PROGRESS_MONITORING: '/app/premium/progress.png',
  WORKOUT_REMINDERS: '/app/premium/reminders.png',
  SMART_PLAN_AND_WORKOUT_BUILDER: '/app/premium/smart.png',
  RECOMMENDED_WORKOUTS: '/app/landing/workouts.png',
  WORKOUT_TRACKER: '/app/landing/workout.png',
  EXERCISE_VIDEOS: '/app/landing/exercises.png'
}
